import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2" }

import EditModalContent from "@/components/TenkoAssociations/EditModalContent.vue";
import RegisterModal from "@/components/Common/RegisterModal.vue";
import { useAuth } from "@/services/user/Auth0UserProvider";
import Api from "@/services/api/ApiServiceFabrick";
import { Ref, ref, computed } from 'vue';
import accountType from "@/types/account";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditModal',
  props: {
    modelValue: { type: Boolean },
    account: {},
    employeeCode: {},
    isRegistered: { type: Boolean }
  },
  emits: ['update:modelValue', 'success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props;

const { loginWithRedirect } = useAuth()
const errors: Ref<{[key: string]: string[]}> = ref({
  employee_cd: [] as string[]
})
const loading: Ref<boolean> = ref(false);
const employeeCd: Ref<string> = ref(setEmployeeCd())

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function setEmployeeCd() {
  return props.employeeCode
}

function createOrUpdateTenkoAssociation() {
  if (props.isRegistered) {
    return updateTenkoAssociation()
  }
  createTenkoAssociation()
}

function createTenkoAssociation() {
  loading.value = true
  const params = makeUpdateParams()
  Api().createTenkoAssociation(params).then(() => {
    loading.value = false
    emits('success');
  }).catch((error) => {
    loading.value = false
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({
          appState: { targetUrl: location.pathname },
        });
        break;
      case 403:
        location.reload();
        break;
      case 422:
        errors.value = res.data.errors;
      }
  })
}

function updateTenkoAssociation() {
  loading.value = true
  const params = makeUpdateParams()
  Api().updateTenkoAssociation(params).then(() => {
    loading.value = false
    emits('success');
  }).catch((error) => {
    loading.value = false
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({
          appState: { targetUrl: location.pathname },
        });
        break;
      case 403:
        location.reload();
        break;
      case 422:
        errors.value = res.data.errors;
      }
  })
}

function makeUpdateParams() {
  return {
    operation_office_id: props.account?.officeable.id,
    driver_id: props.account?.driver_id,
    employee_cd: employeeCd.value
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
    title: _unref(i18n).global.t('pages.tenkoAssociation.editModal.title'),
    note: _unref(i18n).global.t('common.confirmationModal.confirmDelete'),
    confirmBtnName: _unref(i18n).global.t('common.deleteBtn'),
    confirmBtnClass: "bg-danger text-white"
  }, {
    content: _withCtx(() => [
      _createVNode(EditModalContent, {
        account: props.account,
        modelValue: employeeCd.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((employeeCd).value = $event)),
        errors: errors.value
      }, null, 8, ["account", "modelValue", "errors"])
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (modelValue.value = false)),
          class: "reset-btn mr-2",
          disabled: loading.value,
          style: _normalizeStyle({
            backgroundColor : loading.value ? '#B3B8BB' : ''
          })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "style"]),
        _createVNode(_component_v_btn, {
          onClick: createOrUpdateTenkoAssociation,
          class: "exec-btn",
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.saveBtn')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "note", "confirmBtnName"]))
}
}

})